import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as IconsSVG from "../../../../../../assets/iconsSVG";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";

interface Props {
  item: Lead;
}

const UserAvatar: React.FC<{ item: Lead }> = ({ item }) => {
  if (item?.leadDesqualificado) {
    return (
      <div style={{ marginRight: 12, marginLeft: 6 }}>
        <IconsSVG.BolsaoIcon />
      </div>
    );
  }

  if (item?.urlFotoUsuarioCorretorLead) {
    return (
      <img
        style={{
          borderRadius: "50%",
          color: "white",
          marginRight: 12,
          marginLeft: 6,
          width: 22,
          height: 22,
        }}
        alt="foto corretor"
        src={item.urlFotoUsuarioCorretorLead}
      />
    );
  }

  return (
    <div style={{ marginRight: 12, marginLeft: 6 }}>
      <IconsSVG.UserNullIcon />
    </div>
  );
};

export const CorretorCell: React.FC<Props> = ({ item }) => (
  <Tooltip
    followCursor
    title={item?.nomeCorretorLead || "Sem informação"}
    placement="top-start"
    arrow
  >
    <Styles.Td>
      <div
        style={{
          display: "flex",
          justifyContent: "left",
          alignContent: "center",
          width: "100%",
          alignItems: "center",
        }}
      >
        <UserAvatar item={item} />
        {item?.nomeCorretorLead || "--"}
      </div>
    </Styles.Td>
  </Tooltip>
);
